export const environment = {
  apiBaseUrl: 'https://qa.api.sbv360.com',
  environment: 'qa',
  NX_APP_AZURE_AD_CLIENT_ID: 'dda38528-0dd6-4ca2-88b9-dee663f0e413',
  NX_APP_AZURE_AD_AUTHORITY:
    'https://login.microsoftonline.com/de9df500-9b25-4668-8c85-c9cce76cc306/v2.0',
  NX_APP_AZURE_AD_API_SCOPE: 'api://dda38528-0dd6-4ca2-88b9-dee663f0e413/API',
};
